module.exports = __webpack_public_path__ + "static/media/vsn.e3077b88.svg";